package org.example.zone360.pages.coachDetails.sessionAllDetails.summaryBox

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.editSummary
import kotlinx.browser.document
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ResizableTextAreaField
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.EditSummaryRequest
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.SessionDataDetailsResponse
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.JsonConfig
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun EditSummary(
    initialSummary: String,
    onDialogDismiss: () -> Unit,
    sessionData: GetSessionsData,
    toastMessageCall: (String) -> Unit,
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    onSummaryUpdated: (String, String) -> Unit,
    onSummaryEdit: (Int) -> Unit
) {
    val scope = rememberCoroutineScope()
    var isLoading by remember { mutableStateOf(false) }
    var isError by remember { mutableStateOf(false) }

    val editedSummary by remember { mutableStateOf(initialSummary) }
// remove spaces from summary in input field
    var summaryText = editedSummary
        .trim()
        .lines()
        .filter { it.isNotBlank() }.joinToString("\n") { it.trim() }
    scope.launch {
        (document.getElementById(Res.Id.editSummary) as HTMLTextAreaElement).value = summaryText
    }
    Box(
        modifier = Modifier
            .width(if (breakpoint < Breakpoint.MD) 90.percent else 600.px)
            .position(Position.Fixed)
            .zIndex(99999)
            .top(50.percent)
            .left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .width(90.percent)
                .onClick { }
        )
        Box(
            modifier = Modifier
                .padding(all = 24.px)
                .width(90.percent)
                .margin(top = 10.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                )
                .borderRadius(4.px)
                .overflow(Overflow.Auto),
            contentAlignment = Alignment.Center,
        ) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = 20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FieldTitleTextNormalSimple(
                        "Edit Summary",
                        fontSize = 20.px,
                        fontWeight = 600,
                        onClick = {}
                    )

                    FaXmark(
                        modifier = Modifier
                            .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer)
                            .onClick { onDialogDismiss() },
                        size = IconSize.LG
                    )


                }
                ResizableTextAreaField(
                    value = summaryText,
                    onValueChange = { if (it.length <= 1500) summaryText = it },
                    id = Res.Id.editSummary,
                    placeholder = "Edit Summary",
                    resize = false,
                    minHeight = 400.px,
                    width = 100.percent,
                    maxCharLimit = 1500,
                    fontSize = 14.px,
                    isError = isError,
                    errorText = "Please add summary."
                )

                FieldTitleTextNormalSimple(
                    text = "${summaryText.length}/1500",
                    fontWeight = 600,
                    width = 100.percent,
                    textAlign = TextAlign.End,
                    marginTop = 3.px
                )
                CustomSpacer(height = 20.px)
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    CommonButton(
                        text = "Save",
                        isLoading = isLoading,
                        onCLick = {
                            scope.launch {
                                val summaryBox =
                                    (document.getElementById(Res.Id.editSummary) as HTMLTextAreaElement).value
                                if (summaryBox.isEmpty()) {
                                    isError = true
                                } else {
                                    try {
                                        isLoading = true
                                        val request = EditSummaryRequest(
                                            text = summaryBox,
                                            repair_text_before_analysis = false,
                                            session_type = sessionData.sessionType,
                                            coach_name = sessionData.coachName,
                                            player_name = sessionData.playerName,
                                            domain_type = sessionData.domainType,
                                            get_summary = false,
                                            summary_only = true,
                                            edit_only = true,
                                            get_insights = false,
                                            session_id = sessionData.sessionId,
                                            language = sessionData.language,
                                            organization = AppGlobal.userData.organization
                                        )
                                        val response = editSummary(request)
                                        val newSummary = response.response.summary
                                        val onSummaryRevision = response.response.summaryRevision


                                        //  Update only current session’s JSON
                                        val sessionDetails =
                                            JsonConfig.default.decodeFromString<SessionDataDetailsResponse>(
                                                sessionData.sessionData
                                            )
                                        val updatedDetails = sessionDetails.copy(
                                            response = sessionDetails.response.copy(summary = newSummary)
                                        )
                                        val updatedSessionJson =
                                            JsonConfig.default.encodeToString(updatedDetails)
                                        onSummaryEdit(onSummaryRevision)
                                        onSummaryUpdated(newSummary, updatedSessionJson)
                                        toastMessageCall("Summary updated.")
                                        showToast("toastSuccess")
                                        onDialogDismiss()
                                    } catch (e: Exception) {
                                        toastMessageCall("Failed: ${e.message}")
                                    } finally {
                                        isLoading = false
                                    }
                                }
                            }

                        }
                    )
                }
            }
        }
    }
}